"use strict";
/* tslint:disable */
/* eslint-disable */
Object.defineProperty(exports, "__esModule", { value: true });
exports.customerAccountQuery = void 0;
// Based on the generated query
exports.customerAccountQuery = `
customerAccount {
  id
  organizationId
  referenceId
  accountName
  ownerId
  createdBy
  updatedBy
  website
  industry
  region
  territory
  geo
  segment
  contacts {
    lastName
    firstName
    email
    title
  }
}
`;
